import dateFormat from 'dateformat';

/**
 * Nicely format a date from a string
 * @param dateString
 * @return {String}
 */
export function formatDateStringToNiceHumanDate(dateString){
	try {
		return dateFormat(new Date(dateString), "ddd, dd mmm yyyy HH:MM:ss");
	} catch(e){
		return `${e.message} ${dateString}`;
	}
}

/**
 * Get value from local storage
 * @param key
 * @return {string | null}
 */
export function getValueFromLocalStorage(key){
	return localStorage.getItem(key);
}

/**
 * Set value in local storage
 * @param key
 * @param json
 */
export function setValueInLocalStorage(key, json) {
	localStorage.setItem(key, json);
}